




import Meter from "@/components/Meter.vue";
import getHydraTotalItems from "@/service/TotalItemsProvider";

export default {
  name: "Contests",
  components: {
    Meter
  },
  data: () => {
    return {
      result: ''
    }
  },
  mounted() {
    getHydraTotalItems((this as any).$api, '/contests')
      .then((result: string) => ((this as any).result = String(result)))
  },
}
